import BaseModel from './BaseModel';

export default class DataExtractionProgressSummary extends BaseModel {
  constructor(data = {}) {
    super(DataExtractionProgressSummary, data);
    this.needExtractionCount = data.needExtractionCount;
    this.partiallyExtractedCount = data.partiallyExtractedCount;
    this.conflictedExtractionCount = data.conflictedExtractionCount;
    this.extractedCount = data.extractedCount;
    this.requiresExtractionByUserCount =
      data.requiresExtractionByUserCount;
    this.userDraftCount = data.userDraftCount;
  }

  totalRemaining() {
    return (
      this.needExtractionCount +
      this.partiallyExtractedCount +
      this.conflictedExtractionCount
    );
  }

  totalReferenceCount() {
    return (
      this.needExtractionCount +
      this.partiallyExtractedCount +
      this.conflictedExtractionCount +
      this.extractedCount
    );
  }

  remainingUserCanExtract() {
    return (
      this.needExtractionCount + this.requiresExtractionByUserCount
    );
  }
}
